'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/react-router/~/react/react.js
// module id = 10
// module chunks = 95715928098905 168707334958949